// extracted by mini-css-extract-plugin
export default {"giftSvg":"BonusButtons_giftSvg__0mjxr","box":"BonusButtons_box__N8R8A","indicator":"BonusButtons_indicator__hXTFv"};